const fuel_type = [
  {
    id: 0,
    name: 'Gasolina'
  },
  {
    id: 1,
    name: 'Diesel'
  },
  {
    id: 2,
    name: 'Híbrido'
  },
  {
    id: 3,
    name: 'Eléctrico'
  },
  {
    id: 4,
    name: 'Gasolina-Gas'
  },
  {
    id: 5,
    name: 'Gas'
  }
];

const seat_runs = [
  // {
  //   id: 0,
  //   name: '1'
  // },
  {
    id: 1,
    name: '2'
  },
  {
    id: 2,
    name: '3'
  },
  {
    id: 4,
    name: 'Otro'
  }
];

const doors_number = [
  {
    id: 0,
    name: '3'
  },
  {
    id: 1,
    name: '4'
  },
  {
    id: 2,
    name: '5'
  }
];

const tapestry = [
  {
    id: 0,
    name: 'Tela'
  },
  {
    id: 1,
    name: 'Cuero'
  },
  {
    id: 2,
    name: 'Cuero Sintético'
  },
  {
    id: 4,
    name: 'Cuero/Tela'
  },
  {
    id: 3,
    name: 'Otro'
  }
];

const vehicle_type = [
  {
    id: 8,
    name: 'City car'
  },
  {
    id: 0,
    name: 'Sedán'
  },
  {
    id: 1,
    name: 'Hatchback'
  },
  {
    id: 3,
    name: 'Coupé'
  },
  {
    id: 9,
    name: 'Multipropósito'
  },
  {
    id: 2,
    name: 'SUV'
  },
  {
    id: 10,
    name: 'Pick Up'
  },
  {
    id: 4,
    name: 'Microbus'
  },
  {
    id: 5,
    name: 'Van'
  },
  {
    id: 7,
    name: 'Otro'
  }
];

const vehicle_status = [
  {
    id: 0,
    name: 'Seminuevo'
  },
  {
    id: 1,
    name: 'Nuevo'
  }
];

const type = vehicle_type;

const collateral = [
  {
    id: 0,
    name: 'Sí'
  },
  {
    id: 1,
    name: 'No'
  }
];
const gas_convertion = [
  {
    id: 0,
    name: 'No'
  },
  {
    id: 1,
    name: 'GLP'
  },
  {
    id: 2,
    name: 'GNV'
  }
];
export const trays = { retake_letter: 'Aceptación de precio', inspection: 'Inspección mecanica', inspectionFinished: 'Inspección completada' };

const vehicle = { seat_runs, fuel_type, trays, tapestry, doors_number, type, vehicle_type, collateral, vehicle_status, gas_convertion };

export default vehicle;
